<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  saveAddress,
  getAddressById,
} from 'api/archives';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/archives/address/edit',
      formComponents: ['baseForm'],
    };
  },
  computed: {
    detailParams () {
      return {
        addressId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: getAddressById,
    editApi: saveAddress,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
